import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PackageCreatePage() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await api.createPackage({
        name,
        description: description || null,
      });
      navigate(`/packages/${res.package.id}`);
    } catch (err) {
      setError(err instanceof api.ApiError ? err.message : "Failed to create package");
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-6" data-page="package-create" data-state={loading ? "submitting" : error ? "error" : "ready"}>
      <div>
        <h1 className="text-2xl font-semibold">New Package</h1>
        <p className="text-muted-foreground">Create a new advertising package</p>
      </div>

      <form onSubmit={handleSubmit} className="flex max-w-md flex-col gap-4" data-form="package-create">
        {error && <p className="text-sm text-destructive" data-error>{error}</p>}

        <div className="flex flex-col gap-2">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            data-field="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Elite High School Package"
            required
          />
        </div>

        <div className="flex flex-col gap-2">
          <Label htmlFor="description">Description (optional)</Label>
          <Input
            id="description"
            data-field="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="e.g., 20m speed barriers at 10 elite schools"
          />
        </div>

        <div className="flex gap-3">
          <Button type="submit" data-action="submit" disabled={loading}>
            {loading ? "Creating..." : "Create Package"}
          </Button>
          <Button type="button" variant="outline" onClick={() => navigate("/packages")} data-action="cancel">
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
}
